import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';



function contact() {
    
}

export default contact;